import {
    HubConnectionBuilder,
    LogLevel,
    HttpTransportType,
} from '@microsoft/signalr';
export default {
    install(Vue) {
        const connection = new HubConnectionBuilder()
            .withUrl(`${Vue.prototype.$axios.defaults.baseURL}/progress`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets,
            })
            .configureLogging(LogLevel.Information)
            .build();

        const progressHub = new Vue();

        connection.on('ReceiveCaseProgress', caseNo => {
            progressHub.$emit('receive-case-progress', caseNo);
        });

        connection.on('ReceiveServiceProgress', serviceName => {
            progressHub.$emit('receive-service-progress', serviceName);
        });
        
        connection.on('ReceiveServiceCount', serviceCount => {
            progressHub.$emit('receive-service-count', serviceCount);
        });
        
        progressHub.initialise = () => {
            return new Promise((resolve, reject) => {
                connection
                    .start()
                    .then(() => {
                        connection
                            .invoke('getConnectionId')
                            .then(connectionId => {
                                resolve(connectionId);
                            })
                            .catch(err => {
                                reject(err);
                            });
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        };

        progressHub.stop = () => {
            return new Promise((resolve, reject) => {
                connection
                    .stop()
                    .then(() => {
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        };

        Vue.prototype.$progressHub = progressHub;
    },
};
